import Select from './ant';

export default Select;
